/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import parameters from './__generated__/BusinessSummarySpaAppsQuery$parameters.ts';
import type { BusinessSummarySpaAppsQuery } from './__generated__/BusinessSummarySpaAppsQuery.graphql.ts';

type SummaryBusinessEntrypointComponent = EntryPointComponent<
	{
		summaryQuery: BusinessSummarySpaAppsQuery;
	},
	{},
	{},
	{}
>;

export const summaryBusinessEntrypoint: EntryPoint<
	SummaryBusinessEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SummaryBusinessEntrypointComponent>(
		/* webpackChunkName: "async-summary-business-entrypoint" */ './BusinessSummarySpaApps.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				summaryQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
						networkCacheConfig: {
							metadata: { META_SLOW_ENDPOINT: true },
						},
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
						scope: { project: { projectKey } },
						isFilterRefinementEnabled: expValEquals(
							'jira_add_harmonisation_filter_to_summary_view',
							'isEnabled',
							true,
							false,
						),
						isAgenticSummaryViewEnabled: expValEquals(
							'jira_agentic_summary_view',
							'isEnabled',
							true,
							false,
						),
						pulseIntakeIssueSearchInput: {
							jql: `project = "${projectKey}" AND hierarchyLevel = 0 AND created >= -7d`,
						},
						pulseTriageIssueSearchInput: {
							jql: `project = "${projectKey}" AND hierarchyLevel = 0 AND statusCategory = "To Do"`,
						},
						pulseExecuteIssueSearchInput: {
							jql: `project = "${projectKey}" AND hierarchyLevel = 0 AND statusCategory = "In Progress"`,
						},
						pulseDeliveryIssueSearchInput: {
							jql: `project = "${projectKey}" AND hierarchyLevel = 0 AND statusCategory = "Done" AND statusCategoryChangedDate >= -7d`,
						},
						boundedProjectIssueSearchInput: {
							jql: `project = "${projectKey}" AND hierarchyLevel = 0`,
						},
					},
				},
			},
		};
	},
});
